import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog'
import { Toast } from 'primereact/toast'
import React, { useEffect, useRef, useState } from 'react'
import { Toolbar } from 'primereact/toolbar'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { useLocation, useNavigate } from 'react-router-dom'
import { Button } from 'primereact/button'
import { Paginator } from 'primereact/paginator'
import { InputText } from 'primereact/inputtext'
import PerfilService from "business/cadastro/perfil/perfilService"
import Form from "base/Form"


export default function PerfilList() {

    const [service] = useState(new PerfilService())
    const cadastro = useLocation()
    const [perfilList, setPerfilList] = useState([])
    const toast = useRef(null)
    const navigate = useNavigate()
    const [first, setFirst] = useState(cadastro.state?.first || 0)
    const [page, setPage] = useState(cadastro.state?.page || 0)
    const [search, setSearch] = useState(cadastro.state?.search || '')
    const [setRows] = useState(10)
    const [totalRows, setTotalRows] = useState(0)
    const [visitedId] = useState(cadastro.state?.visitedId || [])
    const perPage = 10

    useEffect(() => {
        loadData(page)
    }, [])

    function loadData(selPage) {

        const queryString = `?page=${selPage + 1}&perPage=${perPage}&descricao_perf=${search}`

        service.list(queryString).then((response) => {

            const meta = response.data.meta

            setPerfilList(response.data.data)
            setTotalRows(meta.total)

        }).catch((error) => {
            console.log("Erro: ", error)
        })
    }

    function handleRowNew() {

        navigate(service.getNewFrontUrl())
    }

    function handleRowEdit(data) {
        visitedId.push(data.codigo_perf)
        const ama = service.getIdFrontUrl(data.codigo_perf)
        navigate(ama, { state: { search, page, first, visitedId } })
    }
    function handleRowDelete(data) {

        confirmDialog({
            message: `Confirma excluir o item ${data.codigo_perf}-${data.descricao_perf}?`,
            icon: 'pi pi-exclamation-triangle',
            accept: () => {

                service.delete(data.codigo_perf).then((response) => {
                    const newValue = perfilList.filter((e) => e.codigo_perf != data.codigo_perf)
                    setPerfilList(newValue)
                    toast.current.show({ severity: 'info', summary: 'Deletado', detail: 'Perfil deletado!', life: 3000 })
                }).catch((err) => {

                    const message = err.response.data
                    if (message) {
                        toast.current.show({ severity: 'error', summary: 'Ops!', detail: message, life: 3000 })
                    }

                })

            }

        })
    }

    function handleSearch(data) {
        loadData(0)
        setPage(0)
        setFirst(0)
    }
    function handleSearchKeyUp(data) {
        if (data.key === 'Enter') {
            handleSearch(search)
        }
    }

    function action(data) {
        return (
            <div>
                <Button id='rowEdit' className="mr-1" label="" icon="pi pi-pencil" size="small" onClick={() => handleRowEdit(data)} severity="success" text />
                <Button id='rowDel' label="" icon="pi pi-trash" size="small" onClick={() => handleRowDelete(data)} severity="warning" text />
            </div>
        )
    }
    function leftToolbarTemplate(data) {
        return (
            <div className="p-inputgroup flex-1">
                <span className="p-inputgroup-addon">
                    <i className="pi pi-search"></i>
                </span>
                <InputText id="procurar" placeholder="Procurar" inputMode="search" value={search} onChange={(e) => setSearch(e.target.value)}
                    onKeyUp={handleSearchKeyUp}
                    className='mr-0' />
                <Button label="Pesquisar" icon="pi pi-search" onClick={() => handleSearch(search)} />
            </div>
        )
    }
    function rightToolbarTemplate(data) {
        return (
            <>
                <Button label="Novo" icon="pi pi-plus" severity="success" onClick={handleRowNew} outlined />
            </>
        )

    }
    return (
        <Form title={service.pluralTitle}>

            <ConfirmDialog />
            <Toast ref={toast} />
            <div>
                <Toolbar className="mb-4" start={leftToolbarTemplate} end={rightToolbarTemplate}></Toolbar>
                <DataTable value={perfilList} dataKey="codigo_perf" size="small" showGridlines
                    rows={perPage}
                    tableStyle={{ minWidth: '1rem' }}
                    totalRecords={totalRows}
                    paginatorPosition="bottom"
                    paginatorRight
                    selectionMode="single"
                    rowClassName={(rowData) => visitedId.includes(rowData.codigo_perf) ? 'bg-gray-50' : ''}
                >

                    <Column field="codigo_perf" sortable header="Código"></Column>
                    <Column field="descricao_perf" sortable header="Perfil"></Column>
                    <Column body={action}></Column>

                </DataTable>
                <Paginator

                    first={first}
                    rows={perPage}
                    onPageChange={(event) => {
                        setFirst(event.first)
                        setRows(event.rows)
                        setPage(event.page)
                        loadData(event.page)
                    }}
                    totalRecords={totalRows}
                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                    template={{
                        layout: 'FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport',
                        CurrentPageReport: (options) => {
                            return (
                                <span style={{ color: 'var(--text-color)', userSelect: 'none', width: '120px', textAlign: 'center' }}>
                                    {options.totalRecords} resultados
                                </span>
                            )
                        }
                    }
                    }

                />

            </div >
        </Form >
    )
}